module.exports = __webpack_public_path__ + "img/381.a9d505b8.jpg";